// Module
var code = "<div class=\"login-page\">\n\t<center>\n\t\t<div class=\"login-image\"></div>\n\t</center>\n\n\t<div class=\"container-fluid\">\n\t\t<div class=\"row\"></div>\n\t\t<login-fields></login-fields>\n\t</div>\n</div>";
// Exports
module.exports = code;